import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-xl, 24px);
  padding: 40px var(--spacing-xxxl, 56px);
  border-radius: var(--radius-lg, 16px);
  background: var(--color-white-100, #fff);
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-sm, 8px);
  width: 100%;
  .title {
    color: var(--color-gray-950, #19191b);
    text-align: center;
    font-size: var(--font-size-xl, 24px);
    font-style: normal;
    font-weight: 900;
    line-height: var(--font-line-height-xl, 36px);
  }
`;

export const Description = styled.div`
  color: var(--color-foreground, #404145);
  text-align: center;
  font-size: var(--font-size-md, 16px);
  font-style: normal;
  font-weight: 400;
  line-height: var(--font-line-height-md, 24px);
`;

export const Highlight = styled.strong`
  font-weight: 700;
`;

export const PixiInlineLogo = styled.img`
  display: inline-block;
  height: 14px;
  width: auto;
  vertical-align: baseline;
  margin: 0 2px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md, 12px);
  width: 100%;
`;

export const TalkToSalesButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-sm, 8px);
  width: 100%;
  min-width: 100px;
  height: 44px;
  padding: 0 var(--spacing-lg, 16px);
  border-radius: var(--radius-md, 8px);
  border: 1px solid var(--color-border, #c5c6ca);
  background: var(--color-background, #fff);
  box-shadow: 0px 1px 2px 0px var(--color-black-5, rgba(0, 0, 0, 0.05));
  color: var(--color-foreground, #404145);
  font-family: var(--font-family-studio, Lato);
  font-size: var(--font-size-md, 16px);
  font-weight: 700;
  line-height: var(--font-line-height-md, 24px);
  cursor: pointer;
  i {
    width: var(--size-sm, 24px);
    height: var(--size-sm, 24px);
    color: var(--color-foreground, #404145);
  }
`;
